import { ReactNode } from "react";

/** Labels/help/titles can be ReactNode; placeholders must be string */
type LabelNode = ReactNode;

export interface IVendingInterestCopyUnit {
  appTitle: LabelNode;
  sectionHelpHeader: LabelNode;

  buttons: {
    previous: LabelNode;
    next: LabelNode;
    submit: LabelNode;
    wizardView: LabelNode;
    verticalView: LabelNode;
    demoToggle: LabelNode;
    completeBadge: LabelNode;
  };

  businessProfile: {
    title: LabelNode; // Business Information / Vending Profile
    help: LabelNode;
    fields: {
      businessName: { label: LabelNode; placeholder: string };
      address1: { label: LabelNode; placeholder: string };
      address2: { label: LabelNode; placeholder: string };
      city: { label: LabelNode; placeholder: string };
      state: { label: LabelNode; placeholder: string };
      zip: { label: LabelNode; placeholder: string };
      employeesOnsite: { label: LabelNode; placeholder: string };
      dailyVisitors: { label: LabelNode; placeholder: string };
    };
  };

  contact: {
    title: LabelNode;
    help: LabelNode;
    fields: {
      contactName: { label: LabelNode; placeholder: string };
      role: { label: LabelNode; placeholder: string };
      email: { label: LabelNode; placeholder: string };
      phone: { label: LabelNode; placeholder: string };
    };
  };

  notes: {
    title: LabelNode;
    help: LabelNode;
    fields: {
      notes: { label: LabelNode; placeholder: string };
    };
  };

  submitThankYou: {
    header: LabelNode;
    body: LabelNode;
  };
}

export interface IVendingInterestCopy {
  en: IVendingInterestCopyUnit[]; // variants array; add more entries if needed
}

/* ----------------------------- EN Variant 0 ----------------------------- */
const EN0: IVendingInterestCopyUnit = {
  appTitle: <>Tell Us About Your Location - Vending Request</>,
  sectionHelpHeader: <>Section Help</>,
  buttons: {
    previous: <>Previous</>,
    next: <>Next</>,
    submit: <>Send My Request</>,
    wizardView: <>Wizard View</>,
    verticalView: <>Vertical View</>,
    demoToggle: <>Demo Mode (auto-fill sample data)</>,
    completeBadge: <>Complete</>,
  },

  businessProfile: {
    title: <>Business Information / Vending Profile</>,
    help: <>Where service is needed and what is the typical/approximate number of daily visitors at the location.</>,
    fields: {
      businessName: { label: <>Business Name</>, placeholder: "Business name..." },
      address1: { label: <>Address 1</>, placeholder: "Business address..." },
      address2: { label: <>Address 2 </>, placeholder: "Suite / Unit" },
      city: { label: <>City</>, placeholder: "Denver" },
      state: { label: <>State</>, placeholder: "Select a state…" },
      zip: { label: <>ZIP Code</>, placeholder: "Zip code..." },
      employeesOnsite: { label: <>Number of Employees Onsite</>, placeholder: "e.g. 120" },
      dailyVisitors: { label: <>Number of Daily Visitors</>, placeholder: "e.g. 60" },
    },
  },

  contact: {
    title: <>Contact Information</>,
    help: <>Who should we contact to discuss options and possible solutions?</>,
    fields: {
      contactName: { label: <>Name</>, placeholder: "First and last name." },
      role: { label: <>Role / Department</>, placeholder: "Facilities Manager" },
      email: { label: <>Email</>, placeholder: "you@example.com" },
      phone: { label: <>Phone</>, placeholder: "(###) ###-####" },
    },
  },

  notes: {
    title: <>Notes (Optional)</>,
    help: <>Add any other questions, requests, constraints, timing or other important information.  This information can be discussed over the phone as well.</>,
    fields: {
      notes: { label: <>Notes</>, placeholder: "Preferred install window, brand preferences, etc." },
    },
  },

  submitThankYou: {
    header: <>Thank you!</>,
    body: <>We have receivd your information.  Our team will reach out shortly to discuss options and help you find the best vending solution that fits your requirements.</>,
  },
};

export const VENDING_INTEREST_COPY_V3: IVendingInterestCopy = {
  en: [EN0],
};
